import SLogin from './index.vue';

export {
    SLogin,
};

export default SLogin;
